import { Injectable } from '@angular/core';

@Injectable()
export class QuestionsService {

  public data: any = [ ];

  constructor() {
    if (localStorage.getItem('questions') === null) {
      this.save();
    } else {
      this.load();
    }
  }

  save() {
    localStorage.setItem('questions', JSON.stringify(this.data));
  }

  load() {
    this.data = localStorage.getItem('questions');
    this.data = JSON.parse(this.data);
  }

  public add(tripId, objectId, questionId, answerId = null, good = null) {
      this.data[objectId] = { tripId: tripId, questionId: questionId, answerId: answerId, good: good };
      this.save();
      return true;
  }

  public clearScores(tripId) {
    /*console.log(this.data);*/
    for (let question of this.data) {
      if (question !== null) {
        if (question.tripId === tripId) {
          question.answerId = null;
          question.good = null;
        }
      }
    }
    this.save();
  }

  public countScore(tripId) {
    /*console.log(this.data);*/
    let result = null;
    result = this.data.filter( (element) => {
      if (element !== null) {
        if (element.tripId === tripId && element.good === true) {
          return element;
        }
      }
    });
    result = result.length;
    return result;
  }

}



// WEBPACK FOOTER //
// G:/Projekty/swaythegame/src/app/services/questions.service.ts